import { useEffect } from 'react';
import HeroLab from '@/pages/HeroLab';
import { Expertise } from '@/components/home/EditorialSections';
import { IntroChapter } from '@/components/home/Chapters';
import { FounderProfile, ProofChapter, ContactFooter } from '@/components/home/ClosingChapters';
import { useEditorialReveal } from '@/components/home/useEditorialReveal';

export default function DamianKeyes() {
  const ref = useEditorialReveal<HTMLDivElement>();
  // One scroll handler: exposes --c (0→1 as an element enters) to [data-push] blocks.
  useEffect(() => {
    const root = ref.current;
    if (!root || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const els = Array.from(root.querySelectorAll<HTMLElement>('[data-push]'));
    // Outline → filled phrases: --f follows real scroll progress through the phrase.
    const fills = Array.from(root.querySelectorAll<HTMLElement>('[data-fill]'));
    root.classList.add('ed-fill-on');
    let raf = 0;
    const update = () => {
      raf = 0;
      const vh = window.innerHeight;
      els.forEach((el) => {
        const r = el.getBoundingClientRect();
        el.style.setProperty('--c', Math.max(0, Math.min(1, (vh * 0.95 - r.top) / (vh * 0.6))).toFixed(4));
      });
      fills.forEach((el) => {
        const r = el.getBoundingClientRect();
        el.style.setProperty('--f', Math.max(0, Math.min(1, (vh * 0.95 - r.top) / (vh * 0.45))).toFixed(4));
      });
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => { root.classList.remove('ed-fill-on'); cancelAnimationFrame(raf); window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); };
  }, [ref]);
  useEffect(() => { document.title = 'Damian Keyes | Entrepreneur, BIMM Co-Founder, Creative Education & Music Industry Expert'; }, []);
  return (
    <div className="min-h-screen bg-hero-human">
      <HeroLab embedded variant="consult" />
      {/* Slides over the hero during the existing exit */}
      <div ref={ref} style={{ marginTop: '-100svh' }} className="home-editorial relative isolate z-20 md:rounded-t-[2rem] md:shadow-[0_-24px_60px_-20px_hsl(0_0%_0%/0.35)]">
        <main>
          <IntroChapter />
          <FounderProfile />
          <Expertise />
          <ProofChapter />
        </main>
        <ContactFooter />
      </div>
    </div>
  );
}
